var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-result", class: _vm.messageType }, [
    _c("div", { staticClass: "icon" }),
    _vm._v(" "),
    _c("h1", { domProps: { innerHTML: _vm._s(_vm.messageH1) } }),
    _vm._v(" "),
    _c("p", { domProps: { innerHTML: _vm._s(_vm.messageP) } }),
    _vm._v(" "),
    _vm.resetButton
      ? _c(
          "a",
          {
            staticClass: "btn btn-success",
            attrs: { href: "javascript:" },
            on: {
              click: function ($event) {
                return _vm.$parent.resetForm()
              },
            },
          },
          [_vm._v("Try again")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }